import { useParams } from "react-router-dom";
import Template from "../../components/template";
import Body from "./components/Body";

const Jobsheet = () => {
    const { job_id } = useParams();

    return(
        <Template>
            <div className="container-fluid mt-2">
                <div className="row align-items-start flex-column">
                    <div className="col-lg-5 ms-3 col-sm-8">
                        <h3 className="mb-0 h4 font-weight-bolder">Jobsheet</h3>
                        <p className="mb-4">
                            View and manage jobsheet associated with this job.
                        </p>
                    </div>
                </div>
            </div>

            <Body job_id={job_id} />
        </Template>
    );
};

export default Jobsheet;